import type { WireItem } from "../api/types.js";
import { combinedTireField } from "../domain/format.js";

/**
 * Narrow-viewport replacement for `ItemTable`: the 16-column table cannot
 * survive a 375px screen, so below the narrow breakpoint the list becomes
 * cards showing only what the brief calls out as mattering there — number,
 * customer, car, registration, dimension, flag state.
 *
 * Each card is a real `<button>` (not a clickable `<div>`) so it is
 * keyboard-focusable and activatable with Enter/Space for free, and a
 * single tap opens it — unlike the desktop table's double-click, which
 * mirrors the legacy mouse gesture exactly but does not translate well to
 * touch (a reliable double-tap is slow and easy to mis-time on a phone).
 */
export function ItemCards({ items, onActivate }: { items: WireItem[]; onActivate: (id: string) => void }) {
  return (
    <ul className="item-card-list">
      {items.map((item) => {
        const customer = [item.lastname, item.name].filter(Boolean).join(" ");
        const dimension = combinedTireField(item.tireSets, "dimension", " / ");
        return (
          <li key={item.id}>
            <button
              type="button"
              className={`item-card${item.isFlagged ? " flagged" : ""}`}
              onClick={() => onActivate(item.id)}
            >
              <div className="item-card-row item-card-heading">
                <span className="item-card-number">#{item.number ?? "?"}</span>
                <span className="item-card-customer">{customer || "—"}</span>
              </div>
              <div className="item-card-row">
                <span>{item.carMaker ?? ""}</span>
                <span>{item.registrationNumber ?? ""}</span>
              </div>
              <div className="item-card-row">
                <span className="item-card-dimension">{dimension}</span>
                {item.isFlagged && (
                  <span className="item-card-flag" aria-label="Označeno">
                    !
                  </span>
                )}
              </div>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
